import PropTypes from 'prop-types';

export const roles = PropTypes.shape({
  id: PropTypes.number,
  number: PropTypes.number,
  name: PropTypes.oneOf(['FIELD_TECHNICAL', 'COMMONER', 'BOARD']),
  localized_name: PropTypes.oneOf(['Técnico de campo', 'Comunero', 'Junta rectora'])
});